import { SocketChannel } from 'Modules/Socket'

export enum SocketState {
	CONNECTING,
	OPEN,
	CLOSING,
	CLOSED,
}

export enum MessageCode {
	CLOSE_SERVER = 1006,
	CLOSE = 1000,
}

export enum SocketCommands {
	MESSAGE = 'message',
	SUBSCRIBE = 'subscribe',
	UNSUBSCRIBE = 'unsubscribe',
}

export enum WorkerEvent {
	CONNECT_SOCKET = 'CONNECT_SOCKET',
	CLOSE_CONNECTION = 'CLOSE_CONNECTION',
	SEND_MESSAGE = 'SEND_MESSAGE',
	SUBSCRIBE_CHANNEL = 'SUBSCRIBE_CHANNEL',
	UNSUBSCRIBE_CHANNEL = 'UNSUBSCRIBE_CHANNEL',
	OPEN = 'OPEN',
	CLOSE = 'CLOSE',
	MESSAGE = 'MESSAGE',
	WAKE_UP = 'WAKE_UP',
	PING_LOST = 'PING_LOST',
}

export const defaultChannels = [
	SocketChannel.PING_CHANNEL,
	SocketChannel.NOTIFY_CHANNEL,
	SocketChannel.FRONT_CHANNEL,
	SocketChannel.REPORT_STATE_CHANNEL,
]
